import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_of_the_above_10'

export const dataPointDefinition = {
  retracedId: 'none_of_the_above_10',
  name: 'None of the above',
  description: '',
  meta: {
    slcpMeta: {
      key: 'wi-wor-17x',
      number: 'WI-WOR-13-6',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'wi-wor-11',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[wi-wor-20,Yes,3|wi-wor-20,Yes,2|wi-wor-4,Yes,1]',
      machineShowHide: '[wi-wor-20,1,3|wi-wor-20,1,2|wi-wor-4,1,1]',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-wor-17x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36960,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
